export default {
    //Assign Table
    ASSIGN_NAME: "Name",
    ASSIGN_NOTES: "Notes",
    ASSIGN_CONTACT: "Contact Number",
    ASSIGN_EMAIL: "Email",
    ASSIGN_TABLE: "Assign a Table",
    ASSIGN_ENTER_TABLE_NUMBER: "Enter Table Number",
    ASSIGN_PROCEED: "Proceed without a table number",
    ASSIGN_GUEST_DETAILS: "Guest Details",
    ASSIGN_BUTTON_LABEL: "Assign",
    ASSIGN_CANCEL: "Cancel",
    ASSIGN_SERVER: "Assign a Server",
    ASSIGN_OPTIONAL: "Optional",
    ASSIGN_TABLE_TEXT: "Table",
    ASSIGN_OCCUPIED: "is already occupied! Please select another table",
    ASSIGN_ALREADY_MERGED: "is already merged! Please select another table",
    ASSIGN_SNACKBAR_MSG: "Please select tables from layout to proceed",

    //Check details
    CHECK_DETAILS_POS: "POS",
    CHECK_DETAILS_DISCOUNT_SC: "Discounts and Service Charges",
    CHECK_DETAILS_SUBTOTAL: "Sub Total",
    CHECK_DETAILS_TAX: "TAX",
    CHECK_DETAILS_DISCOUNT: "DISCOUNT",
    CHECK_DETAILS_SVC: "SVC CHG",
    CHECK_DETAILS_TOTAL: "TOTAL",
    CHECK_DETAILS_PAID: "Paid",
    CHECK_DETAILS_TIP: "TIP",
    CHECK_DETAILS_UNPAID: "Unpaid",

    //Check lookup
    CHECK_LOOKUP_SELECT_A_CHECK: "Select a Check",
    CHECK_LOOKUP_CHECK_NUM: "Check#",
    CHECK_LOOKUP_TABLE_NUM: "Table#",
    CHECK_LOOKUP_EMPLOYEE: "Employee",
    CHECK_LOOKUP_OPEN: "Open",
    CHECK_LOOKUP_CLOSE: "Close",
    CHECK_LOOKUP_TOTAL: "Total",

    //Create Waitlist & Update Waitlist
    CREATE_WAITLIST_CREATING_WAITLIST: "Create a waitlist",
    CREATE_WAITLIST_NAME: "Name*",
    CREATE_WAITLIST_PHONE: "Phone Number",
    CREATE_WAITLIST_PARTY_SIZE: "Party Size*",
    CREATE_WAITLIST_EMAIL: "Email-id",
    CREATE_WAITLIST_NOTE: "Note",
    CREATE_WAITLIST_STAFF_COMMENT: "Staff Comment",
    CREATE_WAITLIST_ADD_TO_WAITLIST: "Add to waitlist",
    CREATE_WAITLIST_OPTIONAL: "Optional",
    CREATE_WAITLIST_CANCEL: "Cancel",
    CREATE_WAITLIST_UPDATE_WAITLIST: "Update waitlist",

    //Help Popup
    HELP_POPUP_HELP: "Help",
    HELP_POPUP_ASSIGN: "Assign",
    HELP_POPUP_CHECK_DETAILS: "Check Details",
    HELP_POPUP_RETURN_TO_WAITLIST: "Return to Waitlist",
    HELP_POPUP_UNMERGE_TABLE: "Unmerge Table",
    HELP_POPUP_EDIT_WAITLIST: "Edit Waitlist",
    HELP_POPUP_CLEAR_TABLE: "Clear Table",
    HELP_POPUP_DELETE_WAITLIST: "Delete Waitlist",
    HELP_POPUP_TRANSFER_TABLE: "Transfer Table",
    HELP_POPUP_SMS_GUEST: "SMS Guest",
    HELP_POPUP_MERGE_TABLE: "Merge Table",
    HELP_POPUP_REORDER_WAITLIST: "Reorder Waitlist",
    HELP_POPUP_VOID_CHECK: "Void Check",

    //Table Properties
    PROPERTIES_LABEL: "Table Properties",
    PROPERTIES_CLEAR_TABLE: "Clear Table",
    PROPERTIES_MERGE_TABLE: "Merge Table",
    PROPERTIES_UNMERGE_TABLE: "Unmerge Table",
    PROPERTIES_TRANSFER_TABLE: "Transfer Table",
    PROPERTIES_VOID_CHECK: "Void Check",
    PROPERTIES_SMS_GUEST: "SMS Guest",
    PROPERTIES_CLEAR_MSG: "This will clear the table",
    PROPERTIES_MERGE_TEXT: "This will merge table",
    PROPERTIES_UNMERGE_TEXT: "This will unmerge table",
    PROPERTIES_CONTINUE_MSG: "Are you sure you want to continue?",
    PROPERTIES_CANCEL: "Cancel",
    PROPERTIES_CONTINUE: "Continue",

    //Merge Table
    MERGE_CHOOSE_TABLES: "Choose the tables to merge",

    //TMS Menu
    TMS_MENU_LAYOUT_DESIGN: "Layout Design",
    TMS_MENU_SENSORS: "Sensors",
    TMS_MENU_SYNC_CHECKS: "Sync Checks",
    TMS_MENU_SETTINGS: "Settings",
    TMS_MENU_HELP: "Help",
    TMS_MENU_ABOUT: "About",
    TMS_MENU_TABLE_SENSOR: "Table Sensor",
    TMS_MENU_NAMED_SENSOR: "Named Sensor",

    //Tranfer Table
    TRANSFER_MSG: "Selected station cannot be same as move station",
    TRANSFER_TABLE_TEXT: "Table",
    TRANSFER_OCCUPIED: "is already occupied! Please select another table",
    TRANSFER_SNACKBAR_MSG: "Please select a table from layout to proceed",
    TRANSFER_MOVE_CHECKS: "This will move all checks from table",
    TRANSFER_MOVE_CHECKS_FROM: "This will move the check from table",
    TRANSFER_TO: "to",
    TRANSFER_SELECT_TO_MOVE: "Please select a table to move check",

    //Waitlist
    WAITLIST_NOTES: "Notes",
    WAITLIST_STAFF_COMMENTS: "Staff Comments",
    WAITLIST_ADD_GUEST: "Add Guest",
    WAITLIST_WAITLIST: "Waitlist",
    WAITLIST_SEATED: "Seated",
    WAITLIST_CANCELLED: "Cancelled",

    //Popup Message
    POPUP_MESSAGE_MERGED: "MERGED",
    POPUP_MESSAGE_CONFIRMATION: "Confirmation",
    POPUP_MESSAGE_NO: "No",
    POPUP_MESSAGE_YES: "Yes",
    POPUP_MESSAGE_FETCHING_STORE_LAYOUT_MSG: "Fetching store layout",
    POPUP_MESSAGE_GETTING_MERGED_STATIONS_MSG: "Getting merged stations",
    POPUP_MESSAGE_SEAT_GUEST_WITHOUT_TABLE_CONF_MSG: "Are you sure you want to seat guest without selecting a table",
    POPUP_MESSAGE_SEAT_GUEST_WITHOUT_TABLE_MSG: "Seating Guest without Table Selection",
    POPUP_MESSAGE_MERGING_TABLES_MSG: "Merging Tables",
    POPUP_MESSAGE_SEND_SMS: "Send SMS",
    POPUP_MESSAGE_SEND_SMS_ALL: "Send SMS to All",
    POPUP_MESSAGE_SEND_SMS_CONF_MSG: "This will send an SMS message to the phone number on file. Do you want to continue?",
    POPUP_MESSAGE_SENDING_SMS_MSG: "Sending SMS",
    POPUP_MESSAGE_MOVE: "Move",
    POPUP_MESSAGE_MOVE_ALL: "Move All",
    POPUP_MESSAGE_MOVING_GUEST_MSG: "Moving Guest to a different table",
    POPUP_MESSAGE_UNMERGING_TABLES_MSG: "Unmerging Tables",
    POPUP_MESSAGE_UNSEAT_GUEST: "Unseat Guest",
    POPUP_MESSAGE_UNSEAT_ALL_GUEST: "Unseat All Guests",
    POPUP_MESSAGE_CLEARING_TABLE_MSG: "Clearing the table",
    POPUP_MESSAGE_CLEARING_BOOKING_MSG: "Clearing booking",
    POPUP_MESSAGE_MOVE_TO_WAITLIST_CONF_MSG: "This will move the guest back to the waitlist. Do you want to proceed?",
    POPUP_MESSAGE_CANCELING_BOOKING_MSG: "Canceling booking",
    POPUP_MESSAGE_CANCEL_WAITLIST_CONF_MSG: "This will cancel the waitlist for",
    POPUP_MESSAGE_CREATING_NEW_BOOKING_MSG: "Creating new booking",
    POPUP_MESSAGE_UPDATING_BOOKING_MSG: "Updating booking",
    POPUP_MESSAGE_ASSIGNING_TABLE_MSG: "Assigning Table",
    POPUP_MESSAGE_SEATING_PARTY_MSG: "Seating party",
    POPUP_MESSAGE_SEAT_PARTY_CONF_MSG: "This will seat the party",
    POPUP_MESSAGE_TO_TABLE: "to table",
    POPUP_MESSAGE_MOVING_BOOKING_MSG: "Moving booking",
    POPUP_MESSAGE_SYNCING_WITH_POS_MSG: "Syncing with your POS",
    POPUP_MESSAGE_VOIDING_CHECK_MSG: "Voiding Check",
    POPUP_MESSAGE_CANCEL: "Cancel",

    //About Poup
    ABOUT_POPUP_ABOUT: 'About',
    ABOUT_POPUP_DEVELOPMENT: "Development",
    ABOUT_POPUP_UAT: "UAT",
    ABOUT_POPUP_STAGE: "Stage",
    ABOUT_POPUP_PRODUCTION: "Production",
    ABOUT_POPUP_STORE_NAME: "Store Name",
    ABOUT_POPUP_DEVICE_NAME: "Device Name",
    ABOUT_POPUP_DEVICE_GROUP_NAME: "Device Group Name",
    ABOUT_POPUP_WEB_VERSION: "Web Version",
    ABOUT_POPUP_ENVIRONMENT: "Environment",
    ABOUT_POPUP_FOR_SUPPORT: "For Support",
    ABOUT_POPUP_DOORDASH_DRIVE_DELIVERY: "DoorDash Drive Delivery",
    ABOUT_POPUP_DOORDASH_MARKETPLACE: "DoorDash Marketplace",
    ABOUT_POPUP_GRUBHUB_MARKETPLACE: "Grubhub Marketplace",
    ABOUT_POPUP_UBEREATS_MARKETPLACE: "UberEats Marketplace",
    ABOUT_POPUP_URL: "URL",

    //layout designer
    DESIGNER_NO: "No",
    DESIGNER_YES: "Yes",
    DESIGNER_CANCEL: "Cancel",
    DESIGNER_OK: "Ok",
    DESIGNER_SELECT_SENSOR_GROUP: "Select Sensor Group",
    DESIGNER_SIZE: "Size",
    DESIGNER_POSITION: "Position ",
    DESIGNER_SCALE: "Scale",
    DESIGNER_ANGLE: "Angle",
    DESIGNER_STROKE_WIDTH: "Stroke Width",
    DESIGNER_RECTANGLE: "Rectangle",
    DESIGNER_SQUARE: "Square",
    DESIGNER_CIRCLE: "Circle",
    DESIGNER_POLYGON: "Polygon",
    DESIGNER_DOOR: "Door",
    DESIGNER_WINDOW: "Window",
    DESIGNER_AQUARIUM: "Aquarium",
    DESIGNER_PAINTING: "Painting",
    DESIGNER_RESTROOM: "Restroom",
    DESIGNER_KITCHEN: "Kitchen",
    DESIGNER_TABLE: "Table",
    DESIGNER_SEAT: "Seat",
    DESIGNER_SEATS: "Seats",
    DESIGNER_FILL_STROKE: "Fill Stroke",
    DESIGNER_FILL: "Fill",
    DESIGNER_STROKE: "Stroke",
    DESIGNER_WARNING: "Warning",
    DESIGNER_CONFIRMATION: "Confirmation",
    DESIGNER_CREATE_LAYOUT: "Create your layout",
    DESIGNER_CLICK_ON: "Click on the",
    DESIGNER_ICON_TOP_LEFT: "icon at top-left to create layout",
    DESIGNER_SELECT_TOOL: "Please select a tool",
    DESIGNER_SELECT_STATIC_SHAPE: "Please select a static shape",
    DESIGNER_SELECT_SEAT_CAPACITY: "Please select seat capacity",
    DESIGNER_SELECT_TABLE: "Please select a table",
    DESIGNER_SELECT_TABLE_SHAPE: "Please select a table shape",
    DESIGNER_FETCH_STORE_LAYOUT: "Fetching store layout",
    DESIGNER_UPDATE_STORE_LAYOUT: "Updating layout",
    DESIGNER_SELECT_SENSOR_GROUP_DRAW: "Please select sensor group to draw layout",
    DESIGNER_SELECT_SENSOR_GROUP_SAVE: "Please select sensor group to save layout.",
    DESIGNER_DELETE_LAYOUT: "This action will delete the layout.\n Are you sure want to continue?",
    DESIGNER_CLOSE_LAYOUT: "This action will save the layout.\n Are you sure want to continue?",

    SMS_SUCCESS: 'SUCCESS!',
    SMS_ERROR: 'ERROR!',
    SMS_SUCCESS_MESSAGE: 'Your message was sent successfully',
    SMS_ERROR_MESSAGE: 'Your message could not be sent!',
    SMS_OK: 'OK',
    SMS_TRY_AGAIN: 'TRY AGAIN',
};